import { templateRouteActionTypes } from '@Actions/production/templateRouteActions';

const TemplateRouteReducers = (state = { }, action) => {
  switch (action.type) {
  case templateRouteActionTypes.GET_TEMPLATE_ROUTES.LOADING: {
    const { getTemplateRoutesLoading } = action;
    return {
      ...state,
      getTemplateRoutesLoading,
    };
  }
  case templateRouteActionTypes.GET_TEMPLATE_ROUTES.SUCCESS: {
    const { templateRoutes } = action;
    return {
      ...state,
      templateRoutes,
    };
  }
  case templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.LOADING: {
    const { getTemplateRouteByIdLoading } = action;
    return {
      ...state,
      getTemplateRouteByIdLoading,
    };
  }
  case templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.SUCCESS: {
    const { selectedTemplateRoute } = action;
    return {
      ...state,
      selectedTemplateRoute,
    };
  }
  case templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.LOADING: {
    const { createTemplateRouteLoading } = action;
    return {
      ...state,
      createTemplateRouteLoading,
    };
  }
  case templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.LOADING: {
    const { updateTemplateRouteLoading } = action;
    return {
      ...state,
      updateTemplateRouteLoading,
    };
  }
  case templateRouteActionTypes.UPDATE_ASSIGNEE.LOADING: {
    const { updateAssigneeLoading } = action;
    return {
      ...state,
      updateAssigneeLoading,
    };
  }
  case templateRouteActionTypes.UPDATE_STATUS_TEMPLATE_ROUTE.LOADING: {
    const { updateTemplateRouteStatusLoading } = action;
    return {
      ...state,
      updateTemplateRouteStatusLoading,
    };
  }
  case templateRouteActionTypes.DELETE_TEMPLATE_ROUTE.LOADING: {
    const { deleteTemplateRouteLoading } = action;
    return {
      ...state,
      deleteTemplateRouteLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default TemplateRouteReducers;
